import {TableProps} from '@amzn/awsui-components-react';
import React from 'react';
import {WorkflowExecution} from '../../backend/model';
import {WorkflowHistoryExecutionIdLink} from '../TableItemLink';
import {prettifyDateUTC} from './date';
import WorkflowStatusIndicator from './WorkflowStatusIndicator';

export const workflowHistoryColumns: TableProps.ColumnDefinition<WorkflowExecution>[] = [
    {
        id: 'executionId',
        header: 'Execution ID',
        cell: (workflow: WorkflowExecution): JSX.Element =>
            <WorkflowHistoryExecutionIdLink executionId={workflow.executionId}/>,
    },
    {
        id: 'workflowName',
        header: 'Workflow Name',
        cell: (workflow: WorkflowExecution): string => workflow.workflowName,
    },
    {
        id: 'status',
        header: 'Status',
        cell: (workflow: WorkflowExecution): JSX.Element => <WorkflowStatusIndicator status={workflow.status}/>,
    },
    {
        id: 'region',
        header: 'Region',
        cell: (workflow: WorkflowExecution): string => workflow.region,
    },
    {
        id: 'startedBy',
        header: 'Started By',
        cell: (workflow: WorkflowExecution): string => workflow.startedBy,
    },
    {
        id: 'startedAt',
        header: 'Started At',
        cell: (workflow: WorkflowExecution): string | undefined => prettifyDateUTC(workflow.startedAt),
    },
    {
        id: 'lastModifiedAt',
        header: 'Last Modified At',
        cell: (workflow: WorkflowExecution): string | undefined => prettifyDateUTC(workflow.lastModifiedAt),
    },
]
